export class PsMessageStates {
    static ALL = 0;
    static OPENED = 1;
    static CLOSED = 2;
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/PsMessageStates.js